import { AppProvider } from './providers';

// Router
import AppRouter from '@router/router.tsx';

function App() {
	return (
		<AppProvider>
			<AppRouter />
		</AppProvider>
	);
}

export default App;
